/**
Utils for doing things to the body tag
e.g. remove scrolling for modals and similar
Here because there are probably multiple components that need this behavior
*/

const scrollClass = 'st_noscroll';

/**
given an element or array of elements
add CSS class to disable scrolling
meant for body and html tags only
*/
function disableScroll(elems) {
  if (Array.isArray(elems)) {
    elems.forEach(e => e.classList.add(scrollClass));
  } else {
    elems.classList.add(scrollClass);
  }
}

/**
given an element or array of elements
remove CSS class to disable scrolling
meant for body and html tags only
*/
function enableScroll(elems) {
  if (Array.isArray(elems)) {
    elems.forEach(e => e.classList.remove(scrollClass));
  } else {
    elems.classList.remove(scrollClass);
  }
}

export { disableScroll as d, enableScroll as e };
